'use strict';
(function() {
	angular.module('onboarding.services')
		.factory('carrierSettingsService', carrierSettingsService);

	carrierSettingsService.$inject = ['$http'];

	function carrierSettingsService($http) {

		return {
			lookupCarrierProfileModal: lookupCarrierProfileModal,
			updateCarrierPassword: updateCarrierPassword,
			updateCarrierEmail: updateCarrierEmail
		};

		function lookupCarrierProfileModal(carrierId) {
			return $http.get('/api/carriersettings/profile', { params: { carrierId: carrierId } });
		}

		function updateCarrierPassword(password, carrierId) {
			var request = {
				newValue: password
			};
			if (carrierId) {
				request.carrierId = carrierId;
			} else {
				request.carrierId = -1;
			}

			return $http.post('/api/carriersettings/changepassword', request);
		}

		function updateCarrierEmail(email, carrierId) {
			var request = {
				newValue: email
			};
			if (carrierId) {
				request.carrierId = carrierId;
			} else {
				request.carrierId = -1;
			}

			return $http.post('/api/carriersettings/changeemail', request);
		}
	}
})();
